import { gql } from '@apollo/client'

export const GET_PRODUCT_RATINGS = gql`
    query GetProductRatings (
        $first: Int!,
        $page: Int,
        $where: QueryProductRatingsWhereWhereConditions,
        $orderBy: [QueryProductRatingsOrderByOrderByClause!]
    ) {
        productRatings(
            first: $first,
            page: $page
            where: $where,
            orderBy: $orderBy
        ) {
            data {
                id,
                rating_total,
                rating_functionality,
                rating_documentation,
                rating_support,
                title,
                rating_text,
                created_at,
                user {
                    full_name
                }
            }
            paginatorInfo {
                currentPage
                lastPage
                hasMorePages
                count
                firstItem
                lastItem
                perPage
                total
            }
        }
    }
`
